<script>
	export let offset;
	import {scaleLinear} from "d3-scale";

	let innerWidth = 320;
	let isMobile = innerWidth < 600

	let offsetValStarFadeIn = isMobile ? 0.4 : 0.6;
	let offsetValStar2FadeIn = offsetValStarFadeIn + 0.1
    
    let interpolateBenchTransformY = scaleLinear()
        .domain([0, offsetValStarFadeIn])
        .range([-200, 0])

	let interpolateOpacity = scaleLinear()
        .domain([0, isMobile ? 0.1 : 0.2])
        .range([0, 1])

	$: benchTransformY = Math.min(Math.max(interpolateBenchTransformY(offset), -320), 0);
</script>

<svelte:window bind:innerWidth />

<!-- Generator: Adobe Illustrator 26.5.3, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 320 320" style="enable-background:new 0 0 320 320;" xml:space="preserve">
<style type="text/css">
	.st0{display:none;fill:#DED9CD;}
	.st1{fill:#76B238;stroke:#000000;stroke-width:1.2;stroke-linecap:round;stroke-linejoin:round;}
	.st2{fill:none;stroke:#000000;stroke-width:1.2;}
	.st3{fill:#8D6051;stroke:#000000;stroke-width:1.2;stroke-linecap:round;stroke-linejoin:round;}
	.st4{fill:#FFFFFF;stroke:#000000;stroke-width:1.2;stroke-linecap:round;stroke-linejoin:round;}
	.st5{fill:#FFFFFF;stroke:#000000;stroke-width:1.2;stroke-linecap:round;}
</style>
<rect class="st0" width="320" height="320"/>
<g id="Lawn_00000028319822186572541350000004130033412093002672_">
	<path id="Lawn" class="st1" d="M304.51,315.93H15.48c-11.72,0-17.42-20.35-8.9-31.8l39.03-52.5c2.4-3.24,5.6-5.04,8.9-5.04h208.17
		c3.16,0,6.22,1.64,8.58,4.61l41.82,52.5C322.05,294.94,316.45,315.93,304.51,315.93z"/>
	<line class="st2" x1="171.72" y1="293.8" x2="171.72" y2="299.77"/>
	<line class="st2" x1="115.62" y1="281.71" x2="115.62" y2="287.68"/>
	<path class="st2" d="M286.4,296.94c0,2.98,0,5.97,0,5.97"/>
	<path class="st2" d="M278.66,260.93c0,2.98,0,5.97,0,5.97"/>
	<path class="st2" d="M22.03,299.52c0,2.98,0,5.97,0,5.97"/>
	<path class="st2" d="M40.37,251.8c0,2.98,0,5.97,0,5.97"/>
</g>
<g 
	id="Bench" 
	style="opacity: {interpolateOpacity(offset)}; transform: translate(0px, {benchTransformY}px);"
>
<rect x="218.18" y="210.21" class="st3" width="9.04" height="85.85"/>
<rect x="91.67" y="210.21" class="st3" width="9.04" height="85.85"/>
<rect x="73.59" y="233.18" class="st3" width="172.83" height="12.61"/>
<rect x="73.59" y="220.57" class="st3" width="172.83" height="12.61"/>
<rect x="73.59" y="207.95" class="st3" width="172.83" height="12.61"/>
<circle cx="95.62" cy="214.17" r="1.13"/>
<circle cx="95.62" cy="226.59" r="1.13"/>
<circle cx="95.62" cy="239.02" r="1.13"/>
<circle cx="223.27" cy="214.17" r="1.13"/>
<circle cx="223.27" cy="226.59" r="1.13"/>
<circle cx="223.27" cy="239.02" r="1.13"/>
<path class="st3" d="M237.39,291.56v-4.32l-13.81-2.98c-1.3-0.28-2.57,0.53-2.57,1.64v2.13L237.39,291.56z"/>
<rect x="233.43" y="267.26" class="st3" width="10.17" height="30.5"/>
<path class="st3" d="M80.94,291.56v-4.32l14.29-2.98c1.34-0.28,2.65,0.53,2.65,1.64v2.13L80.94,291.56z"/>
<rect x="75.29" y="267.26" class="st3" width="10.17" height="30.5"/>
<rect x="70.2" y="259.92" class="st3" width="179.61" height="7.91"/>
</g>
<g id="Stars" class:show="{offset > offsetValStarFadeIn}">
	<path class="st4" d="M114.28,144.7c0,0-2.2,0.31-4.09,2.2s-2.2,4.09-2.2,4.09s-0.63-2.52-2.2-4.09c-1.57-1.57-4.09-2.2-4.09-2.2
		s2.2-0.31,4.09-2.2s2.2-4.09,2.2-4.09s0.63,2.52,2.2,4.09C111.76,144.07,114.28,144.7,114.28,144.7z"/>
	<path class="st4" d="M253.22,186.49c0,0-2.2,0.31-4.09,2.2s-2.2,4.09-2.2,4.09s-0.63-2.52-2.2-4.09c-1.57-1.57-4.09-2.2-4.09-2.2
		s2.2-0.31,4.09-2.2s2.2-4.09,2.2-4.09s0.63,2.52,2.2,4.09S253.22,186.49,253.22,186.49z"/>
	<path class="st4" d="M202.39,118.71c0,0-2.2,0.31-4.09,2.2s-2.2,4.09-2.2,4.09s-0.63-2.52-2.2-4.09c-1.57-1.57-4.09-2.2-4.09-2.2
		s2.2-0.31,4.09-2.2s2.2-4.09,2.2-4.09s0.63,2.52,2.2,4.09C199.87,118.09,202.39,118.71,202.39,118.71z"/>
	<path class="st4" d="M56.67,193.27c0,0-2.2,0.31-4.09,2.2s-2.2,4.09-2.2,4.09s-0.63-2.52-2.2-4.09c-1.57-1.57-4.09-2.2-4.09-2.2
		s2.2-0.31,4.09-2.2s2.2-4.09,2.2-4.09s0.63,2.52,2.2,4.09C54.15,192.64,56.67,193.27,56.67,193.27z"/>
	<path class="st4" d="M187.7,151.47c0,0-2.2,0.31-4.09,2.2s-2.2,4.09-2.2,4.09s-0.63-2.52-2.2-4.09c-1.57-1.57-4.09-2.2-4.09-2.2
		s2.2-0.31,4.09-2.2s2.2-4.09,2.2-4.09s0.63,2.52,2.2,4.09C185.19,150.84,187.7,151.47,187.7,151.47z"/>
	<path class="st4" d="M113.63,173.42c0,0-0.24,2.31,1.31,3.86c1.55,1.55,3.86,1.31,3.86,1.31s-2.57,0.02-3.86,1.31
		s-1.31,3.86-1.31,3.86s0.24-2.31-1.31-3.86s-3.86-1.31-3.86-1.31s2.57-0.02,3.86-1.31S113.63,173.42,113.63,173.42z"/>
	<path class="st5" d="M240.15,157.61c0,0-0.24,2.31,1.31,3.86s3.86,1.31,3.86,1.31s-2.57,0.02-3.86,1.31s-1.31,3.86-1.31,3.86
		s0.24-2.31-1.31-3.86s-3.86-1.31-3.86-1.31s2.57-0.02,3.86-1.31S240.15,157.61,240.15,157.61z"/>
	<path class="st5" d="M272.91,197.14c0,0-0.24,2.31,1.31,3.86s3.86,1.31,3.86,1.31s-2.57,0.02-3.86,1.31
		c-1.29,1.29-1.31,3.86-1.31,3.86s0.24-2.31-1.31-3.86s-3.86-1.31-3.86-1.31s2.57-0.02,3.86-1.31
		C272.89,199.71,272.91,197.14,272.91,197.14z"/>
	
</g>

<g id="Stars2" class:show="{offset > offsetValStar2FadeIn}">
	<rect x="131.22" y="167.29" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -80.5575 143.4777)" class="st6" width="3.39" height="3.39"/>
	
	<rect x="205.78" y="187.62" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -73.098 202.1553)" class="st6" width="3.39" height="3.39"/>

	<rect x="37.47" y="203.44" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -133.5826 87.7738)" class="st6" width="3.39" height="3.39"/>
<path class="st4" d="M207.24,58.26c1.57-1.57,2.2-4.09,2.2-4.09s0.31,2.2,2.2,4.09s4.09,2.2,4.09,2.2s-2.52,0.63-4.09,2.2
	c-1.57,1.57-2.2,4.09-2.2,4.09s-0.31-2.2-2.2-4.09c-1.89-1.89-4.09-2.2-4.09-2.2S205.67,59.83,207.24,58.26z"/>
<path class="st4" d="M68.3,100.05c1.57-1.57,2.2-4.09,2.2-4.09s0.31,2.2,2.2,4.09s4.09,2.2,4.09,2.2s-2.52,0.63-4.09,2.2
	c-1.57,1.57-2.2,4.09-2.2,4.09s-0.31-2.2-2.2-4.09s-4.09-2.2-4.09-2.2S66.73,101.62,68.3,100.05z"/>
<path class="st4" d="M119.13,32.27c1.57-1.57,2.2-4.09,2.2-4.09s0.31,2.2,2.2,4.09s4.09,2.2,4.09,2.2s-2.52,0.63-4.09,2.2
	c-1.57,1.57-2.2,4.09-2.2,4.09s-0.31-2.2-2.2-4.09s-4.09-2.2-4.09-2.2S117.56,33.85,119.13,32.27z"/>
<path class="st4" d="M264.85,106.83c1.57-1.57,2.2-4.09,2.2-4.09s0.31,2.2,2.2,4.09c1.89,1.89,4.09,2.2,4.09,2.2
	s-2.52,0.63-4.09,2.2c-1.57,1.57-2.2,4.09-2.2,4.09s-0.31-2.2-2.2-4.09c-1.89-1.89-4.09-2.2-4.09-2.2S263.28,108.4,264.85,106.83z"
	/>
<path class="st4" d="M133.82,65.03c1.57-1.57,2.2-4.09,2.2-4.09s0.31,2.2,2.2,4.09c1.89,1.89,4.09,2.2,4.09,2.2
	s-2.52,0.63-4.09,2.2c-1.57,1.57-2.2,4.09-2.2,4.09s-0.31-2.2-2.2-4.09s-4.09-2.2-4.09-2.2S132.24,66.6,133.82,65.03z"/>
<path class="st4" d="M205.11,93.04c1.29,1.29,3.86,1.31,3.86,1.31s-2.31-0.24-3.86,1.31c-1.55,1.55-1.31,3.86-1.31,3.86
	s-0.02-2.57-1.31-3.86c-1.29-1.29-3.86-1.31-3.86-1.31s2.31,0.24,3.86-1.31c1.55-1.55,1.31-3.86,1.31-3.86
	S203.82,91.75,205.11,93.04z"/>
<path class="st5" d="M78.59,77.23c1.29,1.29,3.86,1.31,3.86,1.31s-2.31-0.24-3.86,1.31s-1.31,3.86-1.31,3.86s-0.02-2.57-1.31-3.86
	s-3.86-1.31-3.86-1.31s2.31,0.24,3.86-1.31s1.31-3.86,1.31-3.86S77.3,75.94,78.59,77.23z"/>
<path class="st5" d="M45.83,116.76c1.29,1.29,3.86,1.31,3.86,1.31s-2.31-0.24-3.86,1.31s-1.31,3.86-1.31,3.86s-0.02-2.57-1.31-3.86
	c-1.29-1.29-3.86-1.31-3.86-1.31s2.31,0.24,3.86-1.31s1.31-3.86,1.31-3.86S44.54,115.47,45.83,116.76z"/>

	<rect x="182.82" y="83.04" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -5.8734 155.2918)" class="st6" width="3.39" height="3.39"/>

	<rect x="108.26" y="103.38" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -42.0901 108.5258)" class="st6" width="3.39" height="3.39"/>

	<rect x="276.58" y="119.2" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -3.9791 232.1748)" class="st6" width="3.39" height="3.39"/>
</g>
</svg>


<style lang="scss">
	#Bench {
		opacity: 0;
		transition: opacity 0.2s, transform 0.2s;
		transition-timing-function: ease;
	}

	#Stars, #Stars2 {
		opacity: 0;
        transition: opacity 0.4s;

        &.show {
            opacity: 1;
        }	
	}

	#Stars2 {
        transition: opacity 0.8s;
	}

	
</style>